import React, { Component, useState, useRef, Fragment } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Select, Input, InputNumber } from 'antd'
import styles from './changeBalanceDialog.module.scss'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class ChangeBalanceForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { submit } = this.props
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })

        return console.error(err)
      }

      submit(values)
    });
  }

  render() {
    const { tenant } = this.props
    const { getFieldDecorator } = this.props.form

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="最终额度"
            required>
            {getFieldDecorator('total_credit', {
              initialValue: tenant && tenant.total_credit,
              rules: [
                {
                  required: true,
                  message: '请输入额度',
                },
              ],
            })(
              <InputNumber style={{width: 120}} min={0} placeholder="额度" />
            )}
            <span style={{marginLeft: 5}}>元</span>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="备注"
            required>
            {getFieldDecorator('desc', {
              rules: [
                {
                  required: true,
                  message: '请输入备注',
                },
              ],
            })(
              <Input.TextArea rows={3} placeholder="输入备注" />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">保存</Button>
          </div>
        </Form>
      </div>
    )
  }
}

const ChangeBalance = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    onCancel={hide}>
    <ChangeBalanceForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'TENANT_CREDIT_DIALOG',
 })(ChangeBalance)
